import { css } from "glamor";
import React, { useEffect, useState } from "react";
import { Accordion, Checkbox } from "semantic-ui-react";
import { spacing } from "../library";
import Label from "../library/forms/Label";
import { colors, uiColors } from "../library/theme";
import MockLevelFieldGroup from "./MockLevelFieldGroup";

const container = css({
  "& + &": {
    marginTop: spacing.m,
    paddingTop: spacing.m,
    borderTop: `1px solid ${uiColors.border}`,
  },
});

const layout = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.l,
    paddingTop: spacing.m,
    paddingBottom: spacing.m,
  },
  label: {
    display: "block",
    marginBottom: spacing.xxs,
    fontSize: 16,
  },
  checkboxLabel: {
    cursor: "pointer",
    color: colors.dark,
    fontWeight: 600,
    fontSize: 16,
  },
};

export default function MockLevelFields({
  label,
  options,
  chosenOption,
  placeholder,
  selectAllLabel,
  fields,
  disabled,
}) {
  const parentLevelOptions = options?.filter((opt) => !opt.sublevelId);
  const childLevelOptions = options?.filter((opt) => opt.sublevelId);
  const selectedFields = fields?.getAll() || [];

  const [isAllSelected, setIsAllSelected] = useState(false);

  const selectAll = React.useCallback(() => {
    if (!fields || !childLevelOptions) return;
    setIsAllSelected(true);
    fields.removeAll();
    childLevelOptions.map((item) => fields.push(item.id));
  }, [fields, childLevelOptions]);

  const deselectAll = React.useCallback(() => {
    if (!fields) return;
    setIsAllSelected(false);
    fields.removeAll();
  }, [fields]);

  const handleSelectAllClick = isAllSelected ? deselectAll : selectAll;

  useEffect(() => {
    setIsAllSelected(false);
    deselectAll();
  }, [chosenOption]);

  useEffect(() => {
    if (
      childLevelOptions.length > 0 &&
      selectedFields.length == childLevelOptions.length
    ) {
      setIsAllSelected(true);
    }
  }, [selectedFields.length, childLevelOptions.length]);

  return (
    <div className={container}>
      {label && (
        <Label style={layout.label} disabled={disabled}>
          {label}
        </Label>
      )}
      <Accordion style={layout.wrapper}>
        {childLevelOptions.length ? (
          <>
            {selectAllLabel && (
              <Checkbox
                style={layout.checkboxLabel}
                onClick={handleSelectAllClick}
                checked={isAllSelected}
                label={selectAllLabel}
              />
            )}
            {parentLevelOptions.map((parentLevelOption, index) => (
              <MockLevelFieldGroup
                key={parentLevelOption.id}
                index={index}
                parentLevelOption={parentLevelOption}
                fields={fields}
                disabled={disabled}
                setIsAllSelected={setIsAllSelected}
                selectedFields={selectedFields}
                chosenOption={chosenOption}
              />
            ))}
          </>
        ) : (
          <p>{`${placeholder || "Nenhuma opção disponível"}`}</p>
        )}
      </Accordion>
    </div>
  );
}
